import { render, staticRenderFns } from "./ShopMenuConfirmModal.vue?vue&type=template&id=4c92632f&"
import script from "./ShopMenuConfirmModal.vue?vue&type=script&lang=ts&"
export * from "./ShopMenuConfirmModal.vue?vue&type=script&lang=ts&"
import style0 from "./ShopMenuConfirmModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports